/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Nudge_TitleInputs */

const en_ui_studio_nudge_title = /** @type {(inputs: Ui_Studio_Nudge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan your next adventure`)
};

const de_ui_studio_nudge_title = /** @type {(inputs: Ui_Studio_Nudge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plane dein nächstes Abenteuer`)
};

/**
* | output |
* | --- |
* | "Plan your next adventure" |
*
* @param {Ui_Studio_Nudge_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_nudge_title = /** @type {((inputs?: Ui_Studio_Nudge_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Nudge_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_nudge_title(inputs)
	return de_ui_studio_nudge_title(inputs)
});